module.exports = __webpack_public_path__ + "img/menu3.7f7b5bec.png";